import React from 'react'
import { TouchableOpacity, View } from 'react-native'
import { BrandMark } from '@warcarp/ui'
import { MaterialCommunityIcons } from '@expo/vector-icons'
import { useTheme } from '../../hooks/useTheme'
import { SupportUnreadBadge } from '../settings/SupportUnreadBadge'
import { HOME_HEADER_HEIGHT } from '../../lib/gameChrome'
import { WebUpdateDot } from '../ui/WebUpdateBadge'
import { LogoEggTrigger } from './logoEgg/LogoEgg'

export function HomeHeader({ displayName, supportUnread = 0, desktop = false, maxWidth, sidePadding,
  onMaps, onBots, onHallOfFame, onSettings,
}: { displayName?: string; supportUnread?: number; desktop?: boolean; maxWidth?: number
  /** Overrides the side padding so the header lines up with the page content below. */
  sidePadding?: number
  onMaps: () => void; onBots: () => void; onHallOfFame: () => void; onSettings?: () => void }) {
  const { theme } = useTheme()
  const ink = theme === 'dark' ? '#e6e1c4' : '#18170f'
  const variant = theme === 'dark' ? 'dark' : 'light'
  const logoHeight = desktop ? 46 : 36
  const actions = [
    { label: 'Browse maps', testID: 'home-browse-maps', icon: 'map' as const, press: onMaps },
    { label: 'Synthetic Command', testID: 'home-bot-hall', icon: 'robot-outline' as const, press: onBots },
    { label: 'Hall of Fame', testID: 'home-hall-of-fame', icon: 'trophy' as const, press: onHallOfFame },
    ...(onSettings ? [{ label: 'My settings', testID: 'home-settings', icon: 'cog' as const, press: onSettings }] : []),
  ]
  return <View className="bg-paper border-b border-olive" style={{ height: desktop ? 96 : HOME_HEADER_HEIGHT,
    paddingHorizontal: sidePadding ?? (desktop ? 24 : 16) }}>
    <View style={{ width: '100%', maxWidth, alignSelf: 'center', flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
      {/* The logo carries who's signed in for screen readers (the visible greeting
          was dropped for brand v2); tests anchor on the same label. */}
      <View accessible accessibilityRole="header" accessibilityLabel={`WarCarp. Signed in as ${displayName ?? ''}`} testID="home-brand-logo">
        {/* Tapping the logo plays an easter egg (LogoEggProvider on the screen); it adds no
            layout and no extra screen-reader element. */}
        <LogoEggTrigger height={logoHeight} variant={variant} centerOnWordmark>
          {fishHidden => <BrandMark kind="logo" height={logoHeight} variant={variant} centerOnWordmark hideFish={fishHidden} />}
        </LogoEggTrigger>
      </View>
      <View className="flex-row items-center gap-2">
        {actions.map(action => <TouchableOpacity key={action.testID} testID={action.testID} accessibilityRole="button"
          accessibilityLabel={action.label} onPress={action.press} style={{ padding: desktop ? 10 : 4 }}>
          <MaterialCommunityIcons name={action.icon} size={desktop ? 25 : 22} color={ink} />
          {action.testID === 'home-settings' && <View style={{ position: 'absolute', right: -6, top: -6 }}><SupportUnreadBadge count={supportUnread} /></View>}
          {action.testID === 'home-settings' && <View style={{ position: 'absolute', right: desktop ? 4 : -2, top: desktop ? 4 : -2 }}><WebUpdateDot /></View>}
        </TouchableOpacity>)}
      </View>
    </View>
  </View>
}
